<template>
  <section class="admin-panel form">
    <mdb-container>
      <mdb-row>
        <mdb-col md="12">
          <h1 class="text-left">
            <strong>Podcast</strong>
          </h1>
          <h6 class="mb-5">
            <router-link to="/admin/podcasts">
              <mdb-icon icon="arrow-left" /> Back
            </router-link>| Editing:
            <span class="text-uppercase">{{newOrEditedPodcast.name}}</span>
          </h6>

          <form class="mb-5" v-on:submit.prevent>
            <!-- Default input name -->
            <mdb-row>
              <mdb-col md="6">
                <label for="name" class="grey-text">Name (url slug)</label>
                <input
                  required
                  v-model="newOrEditedPodcast.name"
                  type="text"
                  id="name"
                  class="form-control"
                />
                <label for="episode" class="grey-text">Episode number</label>
                <input
                  required
                  v-model="newOrEditedPodcast.episodeno"
                  type="text"
                  id="episode"
                  class="form-control"
                />
                <label for="image" class="grey-text">Image URL</label>
                <input
                  v-model="newOrEditedPodcast.imageurl"
                  type="text"
                  id="image"
                  class="form-control"
                />
                <label for="code" class="grey-text">Code</label>
                <textarea v-model="newOrEditedPodcast.code" class="form-control" id="code" rows="5"></textarea>


              </mdb-col>
              <mdb-col md="6">
                <label for="excerpt" class="grey-text">Excerpt</label>
                <textarea
                  v-model="newOrEditedPodcast.excerpt"
                  class="form-control"
                  id="excerpt"
                  rows="5"
                ></textarea>
                <label for="timest" class="grey-text">Description</label>
                <ckeditor
                  :editor="editor"
                  v-model="newOrEditedPodcast.timestampedshownotes"
                  :config="ckeditorconfig"
                ></ckeditor>

                <textarea
                  v-if="false"
                  v-model="newOrEditedPodcast.timestampedshownotes"
                  class="form-control"
                  id="timest"
                  rows="15"
                ></textarea>



                <mdb-btn @click="mthSavePodcast()" color="primary" class="btn-sm my-4" rounded>Save</mdb-btn>
                <router-link to="/admin/podcasts">
                  <mdb-btn color="primary" class="btn-sm my-4" rounded>Back to Podcasts</mdb-btn>
                </router-link>
              </mdb-col>
            </mdb-row>
          </form>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import {
  mdbContainer,
  mdbCollapse,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
  mdbTbl,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import firebase from "firebase/app";
import { store } from "../store";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ContainerMixin, ElementMixin } from "vue-slicksort";
import SortableList from "./SortableList.vue";
import SortableItem from "./SortableItem.vue";
import draggable from "vuedraggable";

export default {
  name: "AdminPodcastsEdit",
  components: {
    ClassicEditor,
    mdbContainer,
    mdbCollapse,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
    mdbTbl,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    SortableItem,
    SortableList,
    draggable
  },
  data() {
    return {
      modal: false,
      newOrEditedPodcast: {
        name: "",
        imageurl: "",
        excerpt: "",
        code: "",
        episodeno: "",
        dateadded: null,
        timestampedshownotes: ""
      },
      podcasts: [],
      refpodcasts: firebase.firestore().collection("podcasts"),
      editor: ClassicEditor,
      ckeditortext: "",
      categorynametext: "",
      subcategorynametext: "",
      ckeditorconfig: {
        // The configuration of the rich-text editor.
      },
      addingCkeditorTextMode: false,
      addingVideoMode: false,
      addingCategoryMode: false,
      addingSubcategoryMode: false,
      dragging: false
    };
  },
  methods: {
    mthSavePodcast() {
      console.log("save clicked");
      console.log(this.$router.currentRoute.path.includes("add"));
      console.log("podcastid=");
      console.log(this.$router.currentRoute.params.podcastid);

      this.newOrEditedPodcast.dateadded = new Date();

      if (this.$router.currentRoute.path.includes("add"))
        firebase
          .firestore()
          .collection("podcasts")
          .add(this.newOrEditedPodcast);

      if (
        this.$router.currentRoute.path.includes("edit") &&
        this.$router.currentRoute.params.podcastid != null
      ) {
        firebase
          .firestore()
          .collection("podcasts")
          .doc(this.$router.currentRoute.params.podcastid)
          .update(this.newOrEditedPodcast);
      }
    }
  },
  created() {
    console.log("created podcastid=");
    console.log(this.$router.currentRoute.params.podcastid);

    if (this.$router.currentRoute.params.podcastid)
      firebase
        .firestore()
        .collection("podcasts")
        .doc(this.$router.currentRoute.params.podcastid)
        .get()
        .then(result => {
          this.newOrEditedPodcast = result.data();
        });

    this.refpodcasts.onSnapshot(querySnapshot => {
      //console.log("onsnapshot fired");
      this.podcasts = [];
      var lp = 0;
      querySnapshot.forEach(doc => {
        lp++;
        this.podcasts.push({
          id: doc.id,
          data: doc.data()
        });
      });
    });
  }
};
</script>

<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}
.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.9s ease;
}
.slide-fade-leave-active {
  transition: all 0.9s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.narrow {
  width: 130px;
}

.categorycell {
  font-weight: bold;
}

.subcategorycell {
  font-weight: bold;
  color: gray;
}
</style>
